// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Utility class for screen readers */
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* Main container */
.wrapper {
  padding: 0px 10px;
  width: 100%;
  position: relative;
  /* Item carousel container */
  /* Show more/less button styling */
}
.wrapper .wrapper-articles {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 10px;
  transition: flex-wrap 0.3s ease-in-out;
  position: relative;
  scrollbar-width: thin;
  scrollbar-color: var(--ion-color-primary) transparent;
  /* Improved accessibility when focused */
  /* Individual item container */
  /* Show all items in grid layout */
  /* Custom scrollbar styling for better visibility */
}
.wrapper .wrapper-articles:focus {
  outline-offset: 2px;
}
.wrapper .wrapper-articles .item {
  min-width: 25%;
  padding: 0px 7px;
  margin-top: 5px;
  width: 25%;
  transition: max-width 0.3s ease-in-out;
  /* Visual indicator for active/selected state */
}
@media (max-width: 992px) {
  .wrapper .wrapper-articles .item {
    min-width: 33%;
    max-width: 33%;
  }
}
.wrapper .wrapper-articles .item[aria-selected=true] {
  position: relative;
}
.wrapper .wrapper-articles.show-list {
  flex-wrap: wrap;
}
.wrapper .wrapper-articles.show-list .item {
  max-width: 25%;
}
@media (max-width: 992px) {
  .wrapper .wrapper-articles.show-list .item {
    min-width: 33%;
  }
}
.wrapper .wrapper-articles::-webkit-scrollbar {
  height: 6px;
}
.wrapper .wrapper-articles::-webkit-scrollbar-track {
  background: transparent;
}
.wrapper .wrapper-articles::-webkit-scrollbar-thumb {
  background-color: var(--ion-color-primary);
  border-radius: 6px;
}
.wrapper .button-show-more {
  width: 95%;
  margin: 20px auto 5px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--ion-color-secondary);
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  transition: background-color 0.2s ease;
  /* Accessibility focus styles */
  /* Hover effect */
  /* Active/press effect */
  /* Arrow indicator */
}
.wrapper .button-show-more:focus {
  outline: 3px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.wrapper .button-show-more:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.wrapper .button-show-more:active {
  background-color: rgba(0, 0, 0, 0.1);
}
.wrapper .button-show-more p {
  font-family: AppFontBold;
  color: var(--ion-color-secondary);
  font-size: 16px;
  margin: 0;
}
.wrapper .button-show-more .arrow-down {
  padding: 5px;
  border: 1px solid var(--ion-color-secondary);
  border-radius: 50%;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 5px;
  transform: rotate(0deg);
  transition: transform 0.3s ease-in-out;
}
.wrapper .button-show-more .arrow-down.rotate {
  transform: rotate(180deg);
}

/* Navigation buttons (back/next) */
.nav-button {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  border-radius: 50%;
  background: var(--ion-color-primary);
  border: none;
  width: 40px;
  height: 40px;
  cursor: pointer;
  z-index: 99;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);
  transition: background-color 0.2s ease, transform 0.2s ease;
  /* Accessibility focus styles */
  /* Keyboard focus only */
  /* Hover effect */
  /* Active/press effect */
}
.nav-button:focus {
  outline: 3px solid white;
  outline-offset: 2px;
  box-shadow: 0px 0px 0px 3px rgba(var(--ion-color-primary-rgb), 0.4);
}
.nav-button:focus-visible {
  outline: 3px solid white;
  outline-offset: 2px;
}
.nav-button:hover {
  background-color: var(--ion-color-primary-shade);
  transform: scale(1.05);
}
.nav-button:active {
  transform: scale(0.95);
}
.nav-button ion-icon {
  fill: white;
  color: white;
  font-size: 20px;
}

/* Back navigation button positioning */
.back-icon {
  position: sticky;
  top: 50%;
  transform: translateY(-50%);
  left: 10px;
}

/* Forward navigation button positioning */
.next-icon {
  position: sticky;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
}

/* High contrast mode enhancements */
.bsg-high-contrast .wrapper-articles {
  /* Thicker scrollbar in high contrast mode */
}
.bsg-high-contrast .wrapper-articles:focus {
  outline: 3px solid #0078d7;
}
.bsg-high-contrast .wrapper-articles .item[aria-selected=true]::after {
  background-color: black;
  height: 3px;
}
.bsg-high-contrast .wrapper-articles::-webkit-scrollbar-thumb {
  background-color: black;
}
.bsg-high-contrast .button-show-more {
  border: 2px solid black;
}
.bsg-high-contrast .button-show-more:focus {
  outline: 3px solid #0078d7;
}
.bsg-high-contrast .button-show-more p {
  color: black;
}
.bsg-high-contrast .button-show-more .arrow-down {
  border: 2px solid black;
}
.bsg-high-contrast .button-show-more .arrow-down ion-icon {
  color: black;
}
.bsg-high-contrast .nav-button {
  background: black;
  border: 2px solid white;
}
.bsg-high-contrast .nav-button:focus {
  outline: 3px solid #0078d7;
  box-shadow: none;
}
.bsg-high-contrast .nav-button ion-icon {
  fill: white;
  color: white;
}

/* Responsive adjustments */
@media (max-width: 992px) {
  .nav-button {
    width: 36px;
    height: 36px;
  }
  .button-show-more p {
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/article-option-group-custom/article-option-group-custom.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA,qCAAA;AACA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AADF;;AAIA,mBAAA;AACA;EACE,iBAAA;EACA,WAAA;EACA,kBAAA;EAEA,4BAAA;EAqEA,kCAAA;AAtEF;AAEE;EACE,aAAA;EACA,2BAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sCAAA;EACA,kBAAA;EACA,qBAAA;EACA,qDAAA;EAEA,wCAAA;EAMA,8BAAA;EAqBA,kCAAA;EAaA,mDAAA;AAtCJ;AADI;EAEE,mBAAA;AAEN;AAEI;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;EACA,sCAAA;EAOA,+CAAA;AANN;ACzCE;EDmCE;IAQI,cAAA;IACA,cAAA;EAEN;AACF;AACM;EACE,kBAAA;AACR;AAMI;EACE,eAAA;AAJN;AAMM;EACE,cAAA;AAJR;ACxDE;ED2DI;IAII,cAAA;EAHR;AACF;AAQI;EACE,WAAA;AANN;AASI;EACE,uBAAA;AAPN;AAUI;EACE,0CAAA;EACA,kBAAA;AARN;AAaE;EACE,UAAA;EACA,qBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,4CAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,sCAAA;EAEA,+BAAA;EAMA,iBAAA;EAKA,wBAAA;EAYA,oBAAA;AAhCJ;AAUI;EACE,2CAAA;EACA,mBAAA;AARN;AAYI;EACE,qCAAA;AAVN;AAcI;EACE,oCAAA;AAZN;AAeI;EACE,wBAAA;EACA,iCAAA;EACA,eAAA;EACA,SAAA;AAbN;AAiBI;EACE,YAAA;EACA,4CAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,sCAAA;AAfN;AAiBM;EACE,yBAAA;AAfR;;AAqBA,mCAAA;AACA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,oCAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,0CAAA;EACA,2DAAA;EAEA,+BAAA;EAOA,wBAAA;EAMA,iBAAA;EAMA,wBAAA;AAnCF;AAiBE;EACE,wBAAA;EACA,mBAAA;EACA,mEAAA;AAfJ;AAmBE;EACE,wBAAA;EACA,mBAAA;AAjBJ;AAqBE;EACE,gDAAA;EACA,sBAAA;AAnBJ;AAuBE;EACE,sBAAA;AArBJ;AAwBE;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAtBJ;;AA0BA,uCAAA;AACA;EACE,gBAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;AAvBF;;AA0BA,0CAAA;AACA;EACE,gBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;AAvBF;;AA0BA,oCAAA;AAEE;EAUE,4CAAA;AAjCJ;AAwBI;EACE,0BAAA;AAtBN;AAyBI;EACE,uBAAA;EACA,WAAA;AAvBN;AA2BI;EACE,uBAAA;AAzBN;AA6BE;EACE,uBAAA;AA3BJ;AA6BI;EACE,0BAAA;AA3BN;AA8BI;EACE,YAAA;AA5BN;AA+BI;EACE,uBAAA;AA7BN;AA+BM;EACE,YAAA;AA7BR;AAkCE;EACE,iBAAA;EACA,uBAAA;AAhCJ;AAkCI;EACE,0BAAA;EACA,gBAAA;AAhCN;AAmCI;EACE,WAAA;EACA,YAAA;AAjCN;;AAsCA,2BAAA;AClQE;EDoQA;IACE,WAAA;IACA,YAAA;EAnCF;EAuCE;IACE,eAAA;EArCJ;AACF","sourcesContent":["@import \"../../../theme/mixins\";\n\n/* Utility class for screen readers */\n.visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* Main container */\n.wrapper {\n  padding: 0px 10px;\n  width: 100%;\n  position: relative;\n  \n  /* Item carousel container */\n  .wrapper-articles {\n    display: flex;\n    justify-content: flex-start; \n    width: 100%;\n    flex-wrap: nowrap;\n    overflow-x: auto;\n    overflow-y: hidden;\n    padding: 10px;\n    transition: flex-wrap 0.3s ease-in-out; \n    position: relative;\n    scrollbar-width: thin;\n    scrollbar-color: var(--ion-color-primary) transparent;\n    \n    /* Improved accessibility when focused */\n    &:focus {\n\n      outline-offset: 2px;\n    }\n    \n    /* Individual item container */\n    .item {\n      min-width: 25%;\n      padding: 0px 7px;\n      margin-top: 5px;\n      width: 25%;\n      transition: max-width 0.3s ease-in-out;\n      \n      @include mobile {\n        min-width: 33%;\n        max-width: 33%;\n      }\n      \n      /* Visual indicator for active/selected state */\n      &[aria-selected=\"true\"] {\n        position: relative;\n        \n      \n      }\n    }\n    \n    /* Show all items in grid layout */\n    &.show-list {\n      flex-wrap: wrap;\n      \n      .item {\n        max-width: 25%;\n        \n        @include mobile {\n          min-width: 33%;\n        }\n      }\n    }\n    \n    /* Custom scrollbar styling for better visibility */\n    &::-webkit-scrollbar {\n      height: 6px;\n    }\n    \n    &::-webkit-scrollbar-track {\n      background: transparent;\n    }\n    \n    &::-webkit-scrollbar-thumb {\n      background-color: var(--ion-color-primary);\n      border-radius: 6px;\n    }\n  }\n  \n  /* Show more/less button styling */\n  .button-show-more {\n    width: 95%;\n    margin: 20px auto 5px;\n    padding: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid var(--ion-color-secondary);\n    border-radius: 8px;\n    background: transparent;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n    \n    /* Accessibility focus styles */\n    &:focus {\n      outline: 3px solid var(--ion-color-primary);\n      outline-offset: 2px;\n    }\n    \n    /* Hover effect */\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.05);\n    }\n    \n    /* Active/press effect */\n    &:active {\n      background-color: rgba(0, 0, 0, 0.1);\n    }\n    \n    p {\n      font-family: AppFontBold;\n      color: var(--ion-color-secondary);\n      font-size: 16px;\n      margin: 0;\n    }\n    \n    /* Arrow indicator */\n    .arrow-down {\n      padding: 5px;\n      border: 1px solid var(--ion-color-secondary);\n      border-radius: 50%;\n      width: 25px;\n      height: 25px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      margin-left: 5px;\n      transform: rotate(0deg);\n      transition: transform 0.3s ease-in-out;\n      \n      &.rotate {\n        transform: rotate(180deg);\n      }\n    }\n  }\n}\n\n/* Navigation buttons (back/next) */\n.nav-button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0;\n  border-radius: 50%;\n  background: var(--ion-color-primary);\n  border: none;\n  width: 40px;\n  height: 40px;\n  cursor: pointer;\n  z-index: 99;\n  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);\n  transition: background-color 0.2s ease, transform 0.2s ease;\n  \n  /* Accessibility focus styles */\n  &:focus {\n    outline: 3px solid white;\n    outline-offset: 2px;\n    box-shadow: 0px 0px 0px 3px rgba(var(--ion-color-primary-rgb), 0.4);\n  }\n  \n  /* Keyboard focus only */\n  &:focus-visible {\n    outline: 3px solid white;\n    outline-offset: 2px;\n  }\n  \n  /* Hover effect */\n  &:hover {\n    background-color: var(--ion-color-primary-shade);\n    transform: scale(1.05);\n  }\n  \n  /* Active/press effect */\n  &:active {\n    transform: scale(0.95);\n  }\n  \n  ion-icon {\n    fill: white;\n    color: white;\n    font-size: 20px;\n  }\n}\n\n/* Back navigation button positioning */\n.back-icon {\n  position: sticky;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 10px;\n}\n\n/* Forward navigation button positioning */\n.next-icon {\n  position: sticky;\n  top: 50%;\n  transform: translateY(-50%);\n  right: 10px;\n}\n\n/* High contrast mode enhancements */\n.bsg-high-contrast {\n  .wrapper-articles {\n    &:focus {\n      outline: 3px solid #0078d7;\n    }\n    \n    .item[aria-selected=\"true\"]::after {\n      background-color: black;\n      height: 3px;\n    }\n    \n    /* Thicker scrollbar in high contrast mode */\n    &::-webkit-scrollbar-thumb {\n      background-color: black;\n    }\n  }\n  \n  .button-show-more {\n    border: 2px solid black;\n    \n    &:focus {\n      outline: 3px solid #0078d7;\n    }\n    \n    p {\n      color: black;\n    }\n    \n    .arrow-down {\n      border: 2px solid black;\n      \n      ion-icon {\n        color: black;\n      }\n    }\n  }\n  \n  .nav-button {\n    background: black;\n    border: 2px solid white;\n    \n    &:focus {\n      outline: 3px solid #0078d7;\n      box-shadow: none;\n    }\n    \n    ion-icon {\n      fill: white;\n      color: white;\n    }\n  }\n}\n\n/* Responsive adjustments */\n@include mobile {\n  .nav-button {\n    width: 36px;\n    height: 36px;\n  }\n  \n  .button-show-more {\n    p {\n      font-size: 14px;\n    }\n  }\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
